<!--
 * @Author: zouyuping
 * @version: 
 * @Date: 2022-04-18 15:48:13
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-11-07 18:06:33
 * @FilePath: 
 * @Description: 自助结账消费详情页
-->
<template>
  <div>
    <div class="card_list_con">
      <div class="card_top_con f-bt">
        <div class="">待结算商品</div>
        <!-- <van-button
          color="var(--tc)"
          size="small"
          round
          @click="handleSelectAllGoods"
          >全选</van-button
        > -->
      </div>
      <van-collapse v-model="openValue">
        <van-collapse-item
          v-for="(item, index) in cardList"
          :key="index"
          :name="index"
        >
          <template #title>
            <div class="goods_list_name">
              <img src="@/assets/images/card-icon.png" />
              {{ roomcode ? item.RoomCode + "-" + item.BedCode : item.KeyCode }}
              <!-- <span class="m-r-7" v-if="!roomcode"
                >（此手牌号{{ item.isReserve ? "留牌" : "离店" }}）</span
              > -->
              <span
                v-if="!roomcode"
                @click.stop="handleChangeReserve(item, index)"
                style="color: #573500"
                class="m-l-7"
                >{{ item.isReserve ? "取消留牌" : "留牌" }}</span
              >
            </div>
          </template>
          <div class="content">
            <div
              class="good_item_con"
              v-for="(gItem, gIndex) in item.Orders"
              :key="gIndex"
            >
              <!-- <div class="m-r-15 m-l-20">
                
                <van-radio :name="gItem.ConsumeId">
                  <template #icon="props">
                    <img
                      class="img-icon"
                      :src="gItem.isChecked ? activeIcon : inactiveIcon"
                    />
                  </template>
                </van-radio>
              </div> -->

              <div class="f-1 f-bt my-font-size-28">
                <div class="f-bt f-1">
                  <div class="c-f">
                    <span>{{ gItem.GoodsName }}</span>
                    <i class="tag_con" v-if="gItem.deductText">{{
                      gItem.deductText
                    }}</i>
                  </div>

                  <span class="number_con">× {{ gItem.NumberCount }}</span>
                </div>
                <div class="price_con">
                  ￥<span class="bold">{{ gItem.Price }}</span>
                </div>
              </div>
            </div>
            <div class="little_price_con p-5">
              <div>
                小计：￥<span class="my-brown-color my-font-size-30 bold">{{
                  item.littleMoney
                }}</span>
              </div>
            </div>
          </div>
        </van-collapse-item>
      </van-collapse>
      <!-- <uni-collapse v-for="(item,index) in cardList" :key="index" v-model="openValue">
				<uni-collapse-item>
					<template v-slot:title>
						<div class="goods_list_name">
							<image src="@/static/images/watch.png"></image>
							{{roomcode?item.RoomCode+'-'+item.BedCode:item.KeyCode}}
							<text class="uni-mr-7" v-if="!roomcode">（此手牌号{{item.isReserve?'留牌':'离店'}}）</text>
							<text v-if="!roomcode"
								@click.stop="handleChangeReserve(item,index)">{{item.isReserve?'离店':'留牌'}}</text>
						</div>

					</template>
					<div class="content">

						<div class="good_item_con" v-for="(gItem,gIndex) in item.Orders" :key="gIndex"
							@click="handleCheckGoodsItem(index,gIndex)">
							<div class="uni-mx-3">

								<uni-icons :type="gItem.isChecked?'circle-filled':'circle'"
									:color="gItem.isChecked?'#573500':'#ccc'" size="16">
								</uni-icons>

							</div>

							<div class="my-flex-1 my-flex my-flex-between my-font-size-28">
								<div class="my-flex my-flex-between my-flex-1">
									<text>{{gItem.GoodsName}}</text>
									<text class="my-grey-color">× {{gItem.NumberCount}}</text>
								</div>
								<div class="price_con my-brown-color my-font-bold">
									￥ {{gItem.Price}}
								</div>
							</div>
						</div>
						<div class="my-flex my-flex-end uni-pa-5">
							<div>小计：￥<text
									class="my-brown-color my-font-size-30 my-font-bold">{{item.littleMoney}}</text>
							</div>
						</div>
					</div>


				</uni-collapse-item>
			</uni-collapse> -->
    </div>
    <!-- <div class="card_list_con pay_list_con uni-pa-7 my-white-box">
			<div :class="[{'active':payMethod=='wechat'},'pay_card_con']" @click="handleSelectPayMethod('wechat')">
				<div class="top_dot" v-if="payMethod=='wechat'"></div>
				<span>微信支付</span>
				<img src="@/static/images/wechat.png" />
			</div>
			<div :class="[{'active':payMethod=='card'},'pay_card_con']" @click="handleSelectPayMethod('card')">
				<div class="top_dot" v-if="payMethod=='card'"></div>
				<span>会员卡支付</span>
			</div>
			<scroll-div class="scroll-div_H " scroll-x="true">
				<div class="card_box">


					<div v-for="(v,index) in memberList" :key="index" class="card_item"
						@click="onDefrayalSelect(v, index)">
						<div class="card_top">
							<div>
								<div class="my-font-size-26 my-font-bold">{{v.CardTypeName}}</div>
								<div v-if="v.flag" class="my-font-size-14 uni-mt-5">您的余额不足</div>
							</div>
							<div v-if="selectedMemberInfo.CardCode === v.CardCode" class="select_icon">

								<uni-icons type="checkbox-filled" size="24" color="#DCC494"></uni-icons>
							</div>
						</div>
						<div class="card_btm my-flex my-flex-between">
							<div class="my-font-size-19">
								<span>￥</span>
								<span>{{v.totalMoney}}</span>
							</div>
							
						</div>
					</div>
				</div>
			</scroll-div>
		</div> -->
    <div class="bottom_submit_con f-bt">
      <div class="c-f my-font-size-22">
        <div>
          合计：￥<span class="num_con my-brown-color">{{
            moneyObj.waitPayMoney
          }}</span>
        </div>

        <b class="c-sub-money" v-if="moneyObj.consumeMoney">
          <span class="">￥</span>{{ moneyObj.consumeMoney }}
        </b>
      </div>
      <div class="sub_btn_con">
        <van-button
          color="var(--tc)"
          size="small"
          round
          :disabled="isDisabled"
          @click="handlePayGoods"
          >立即支付</van-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { getCardConsumeList, getCardConsumeMoney } from "@/api/scan.js";
import { Dialog } from "vant";
import { loading } from "@/utils/index";
import { handleTimeLocalStorage } from "@/utils";

export default {
  name: "HandCardPay",
  props: {},
  data() {
    return {
      roomcode: undefined,
      openValue: [0],
      cardList: [],
      payMethod: "wechat",
      memberList: [],
      selectedMemberInfo: {},
      moneyObj: { waitPayMoney: 0, consumeMoney: 0 },
      activeIcon: require("@/assets/radio/radio-active-2.png"),
      inactiveIcon: require("@/assets/radio/radio-unactive-2.png"),
    };
  },
  components: {},
  computed: {
    isDisabled() {
      return (
        this.cardList.length == 0 ||
        !this.orderId ||
        this.moneyObj.waitPayMoney == 0
      );
    },
  },
  created() {
    console.log(this.$store.state.vpnInfo);
    const queryData = this.$route.query;
    this.checkinsIdArr =
      queryData.checkinsIdStr && queryData.checkinsIdStr.split(",");
    this.departId = queryData.depart;
    this.vpncode = queryData.vpncode;
    this.roomcode = queryData.roomcode;
    this.vpnId = this.$store.state.vpnId;
    this.init();
    // this.handleGetMemberList();
  },
  mounted() {},
  methods: {
    init() {
      let params = this.departId
        ? {
            CheckinsId: this.checkinsIdArr,
            VpnId: this.vpnId,
            DepartId: this.departId,
          }
        : {
            RoomCodes: [this.roomcode],
            SaasVpncode: this.vpncode,
          };
      console.log(params);
      loading();
      getCardConsumeList(params).then((res) => {
        const listData = res.ConsumeViewModelList;
        listData.forEach((v, i) => {
          v.isReserve = false; //是否留牌
          v.littleMoney = 0;
          v.Orders.forEach((val) => {
            val.deductText = "";
            val.isChecked = true;
          });
        });
        this.cardList = listData;
        this.orderId = res.OrderId;
        this.outTradeNo = res.OutTradeNo;
        if (!res.OrderId) {
          this.$toast("手牌暂无消费项");
        }
        this.getLittleMoney();
        this.handleGetCardConsumeMoney();
      });
    },
    handleChangeReserve(item, index) {
      const _this = this;
      if (item.isReserve) {
        item.isReserve = false;
        _this.handleGetCardConsumeMoney();
      } else {
        Dialog.confirm({
          title: "留牌提醒",
          message: "确认结账暂时不离店吗？",
          cancelButtonText: "否",
          confirmButtonText: "是",
        })
          .then(() => {
            // on confirm
            item.isReserve = true;
            _this.handleGetCardConsumeMoney();
          })
          .catch(() => {
            // on cancel
          });
        // uni.showModal({
        // 	title: '留牌提醒',
        // 	content: '确认结账暂时不离店吗? ',
        // 	cancelText: '否',
        // 	confirmText: '是',
        // 	success: function(res) {
        // 		if (res.confirm) {
        // 			item.isReserve = true
        // 			_this.handleGetCardConsumeMoney()
        // 		} else if (res.cancel) {
        // 			console.log('用户点击取消');
        // 		}
        // 	}
        // });
      }
    },
    // 全选
    handleSelectAllGoods() {
      this.cardList.forEach((v) => {
        v.littleMoney = 0;
        v.Orders.forEach((val) => {
          val.isChecked = true;
          v.littleMoney = this.$calc.add(
            v.littleMoney,
            this.$calc.multiply(val.Price, val.NumberCount)
          );
        });
      });
      this.handleGetCardConsumeMoney();
    },
    handleCheckGoodsItem(bIndex, index) {
      console.log("选择");
      this.cardList[bIndex].Orders[index].isChecked =
        !this.cardList[bIndex].Orders[index].isChecked;
      this.getLittleMoney();
      this.handleGetCardConsumeMoney();
    },
    // 获取小计的钱数
    getLittleMoney() {
      let unSelectArr = [];
      this.cardList.forEach((v) => {
        v.littleMoney = 0;
        v.Orders.forEach((val) => {
          if (val.isChecked) {
            v.littleMoney = this.$calc.add(
              v.littleMoney,
              this.$calc.multiply(val.Price, val.NumberCount)
            );
          }
        });
      });
      console.log(this.cardList);
    },
    handleGetCardConsumeMoney() {
      if (!this.orderId) return;
      // this.$toast("计算中");
      let allPayList = [];
      this.cardList.forEach((v) => {
        let orderArr = [];
        v.Orders.forEach((val) => {
          if (val.isChecked) {
            orderArr.push({
              ConsumeId: val.ConsumeId,
            });
          }
        });
        allPayList.push({
          CheckinId: v.CheckinId,
          IsReserve: v.isReserve,
          Orders: orderArr,
        });
      });
      const param = {
        OrderId: this.orderId,
        ConsumeViewModelList: allPayList,
      };
      this.allPayList = allPayList;
      getCardConsumeMoney(param)
        .then((res) => {
          // uni.hideLoading();
          // 匹配套票/减免
          const deductList = res.DeductConsumes;
          if (deductList && deductList.length > 0) {
            this.cardList.forEach((v) => {
              v.Orders.forEach((val) => {
                const deductItem = deductList.find(
                  (dItem) => dItem.ConsumeId == val.ConsumeId
                );
                if (deductItem) {
                  val.deductText =
                    deductItem.DeductType == 1
                      ? "套票x" + deductItem.DeductCount
                      : deductItem.DeductType == 2
                      ? "减免x" + deductItem.DeductCount
                      : "";
                }
              });
            });
          }

          this.moneyObj = {
            waitPayMoney: res.WaitPayMoney,
            consumeMoney: res.ConsumeMoney,
          };
        })
        .catch(() => {
          // uni.hideLoading();
        });
    },
    handlePayGoods() {
      this.$store.commit("setStoreVal", { orderId: this.orderId });
      handleTimeLocalStorage.set("settleConsumeList", this.allPayList || []);
      this.$router.push({
        name: "PayList",
        // query: { id: res, fromPage: "goodsmall" },
        query: {
          id: this.orderId,
          fromPage: "handCardPay",
          sequenceId: this.outTradeNo,
          priceData: this.moneyObj.waitPayMoney,
        },
      });
    },
  },
};
</script>
<style scoped lang="scss">
.card_list_con {
  box-shadow: 0px 2px 0px 0px rgba(194, 194, 194, 0.5);
  margin-bottom: 16px;
  background: #fff;
  padding-bottom: 80px;
  .card_top_con {
    padding: 20px 32px;
  }
}

.pay_list_con {
  padding-bottom: 120px;
}

.goods_list_name {
  // height: 80px;
  // line-height: 80px;

  img {
    width: 40px;
    height: 40px;
    margin-right: 10px;
    vertical-align: -6px;
  }
}
.good_item_con {
  display: flex;
  align-items: center;
  // padding: 25rpx 0;
  margin: 15px 0;
  padding-right: 5px;
  color: #333333;
  .img-icon {
    width: 20px;
    height: 20px;
    vertical-align: 3px;
  }
  .price_con {
    width: 155px;
    text-align: right;
    color: #573500;
  }
  .tag_con {
    background-color: #ff6010;

    border-radius: 20px;
    padding: 1px 10px;
    color: #fff;
    font-size: 20px;
    margin-left: 10px;
  }
  .number_con {
    color: #666;
  }
}
.bottom_submit_con {
  @include fixed-bottom-box-con;
  border-top: 1px solid #ececec;
  .num_con {
    color: #573500;
  }
  .c-sub-money {
    line-height: unset;
    margin-left: 10px;
  }
}
.little_price_con {
  display: flex;
  justify-content: flex-end;
  color: #666;
  span {
    color: #573500;
    font-size: 28px;
  }
}
</style>
